import { sendContactRequest, subscribeToNewsletter } from './contactService.server';

const contactService = {
  sendContactRequest,
  subscribeToNewsletter
};

export { contactService as contact };
